import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getChoferes,
  deleteChofer,
  getChoferById,
} from "../helpers/rutaChoferes";
import ModalChofer from "./ModalChofer";
import "../css/tableclientes.css";

const TableChoferes = () => {
  const [choferes, setChoferes] = useState({ data: {}, loading: true });
  const [chofer, setChofer] = useState({});
  const [show, setShow] = useState(false);

  // 🔧 Definí anchos por columna (px o %)
  const COL_W = {
    acciones: 140,      // más ancho
    nro: 80,
    cli: 280,           // Razón Social más ancho
    dom: 320,           // Domicilio más ancho
    tel: 140,
    cuit: 140,
    email: 180,         // más angosto
    loca: 120,          // más angosto
  };

  useEffect(() => { consultaChoferes(); }, []);

  const consultaChoferes = () => {
    getChoferes().then((datos) => {
      setChoferes({ data: datos, loading: false });
    });
  };

  const handleClose = () => { setShow(false); consultaChoferes(); };
  const handleShow = () => setShow(true);

  const modificaChofer = (id) => {
    getChoferById(id).then((resp) => {
      if (resp.ok) {
        setChofer(resp.chofer);
        handleShow();
      } else {
        console.error("❌ Error al obtener chofer:", resp.error);
      }
    });
  };

  const eliminarChofer = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el chofer?");
    if (confirmar) deleteChofer(id).then(consultaChoferes);
  };

  const lista = choferes?.data?.choferes || [];

  return (
    <div className="table-container">
      {!choferes.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container choferes-fixed">
              {/* 🔹 Control fino de anchos */}
              <colgroup>
                <col style={{ width: COL_W.acciones }} />
                <col style={{ width: COL_W.nro }} />
                <col style={{ width: COL_W.cli }} />
                <col style={{ width: COL_W.dom }} />
                <col style={{ width: COL_W.tel }} />
                <col style={{ width: COL_W.cuit }} />
                <col style={{ width: COL_W.email }} />
                <col style={{ width: COL_W.loca }} />
              </colgroup>

              <thead>
                <tr className="header">
                  <th className="acciones">Acciones</th>
                  <th className="nro">Nro</th>
                  <th className="cli">Razón Social</th>
                  <th className="dom">Domicilio</th>
                  <th className="tel">Teléfono</th>
                  <th className="cuit">CUIT</th>
                  <th className="email">Email</th>
                  <th className="loca">Localidad</th>
                </tr>
              </thead>
              <tbody>
                {lista.map((ch) =>
                  ch.activo ? (
                    <tr key={ch._id}>
                      <td className="acciones">
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaChofer(ch._id)}
                          title="Editar"
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarChofer(ch._id)}
                          title="Eliminar"
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td className="nro" title={ch.codcho || ""}>{ch.codcho}</td>
                      <td className="cli text-truncate" title={ch.nombre || ""}>{ch.nombre}</td>
                      <td className="dom text-truncate" title={ch.domicilio || ""}>{ch.domicilio}</td>
                      <td className="tel text-truncate" title={ch.telefono || ""}>{ch.telefono}</td>
                      <td className="cuit text-truncate" title={ch.cuit || ""}>{ch.cuit}</td>
                      <td className="email text-truncate" title={ch.email || ""}>{ch.email}</td>
                      <td className="loca text-truncate" title={ch.localidad?.localidad || "-"}>
                        {ch.localidad?.localidad || "-"}
                      </td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <ModalChofer show={show} handleClose={handleClose} chofer={chofer} />
        </>
      )}
    </div>
  );
};

export default TableChoferes;
